import React from "react";

import { GrMap } from "react-icons/gr";
import {connect} from "react-redux";
import Workspace from "./Workspace";
import NewWorkspace from "./NewWorkspace";

const WorkspaceList = ({data}) => {

    /*data && data.sort(function(a, b){
        return a.id < b.id ? -1 : 1
    });*/

    const _minWidth = 200
    const _height = window.innerHeight - 150

    return (
        <div>
            <div className="list listHeader" style={{
                minWidth: _minWidth,
            }}>
                <GrMap/>&nbsp;Workspace
            </div>
            <div className="list listBody" style={{
                minWidth: _minWidth,
                height: _height,
                overflowY: 'auto',
            }}>
                {data && data.map(it =>
                    <Workspace key={it.id} data={it}/>
                )}
            </div>
        </div>
    )
}

//  <NewWorkspace/>

function mapStateToProps(state, other) {

    const ret = state.plan.items.filter( it => it.typename === "scenario")

    return {data: ret}
}

export default connect(mapStateToProps)(WorkspaceList)
